import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApAnalyticsModule } from '@ap/analytics';

import { ApAdobeTargetModule } from './adobe-target/adobe-target.module';
import { ApPersonalizationComponent } from './personalization.component';
import { ApAdobeTargetService } from './adobe-target/adobe-target.service';
import { ApPersonalizationService } from './personalization.service';

@NgModule({
    imports: [CommonModule, ApAnalyticsModule, ApAdobeTargetModule, ApPersonalizationComponent],
    exports: [ApPersonalizationComponent],
    providers: [
        {
            provide: ApPersonalizationService,
            useClass: ApAdobeTargetService
        }
    ]
})
export class ApPersonalizationModule {}
